/* eslint-disable no-magic-numbers */

import { SeeMoreBlock } from "components/blocks";
import { className } from "utils/strings";
import { UserTile } from "./UserTile";

import { IUserInfo } from "./types";
import "./UserListWidget.scss";

const MAX_ITEMS = 8;

interface IUserListWidget {
  title: string;
  link: string;
  items: IUserInfo[];
  className?: string;
  isExplore?: boolean;
  list?: boolean;
}

export const UserListWidget = (props: IUserListWidget): JSX.Element => {
  return (
    <SeeMoreBlock
      header={props.title}
      more={props.link}
      className={className({
        "newlyVerifiedCreators": true,
        "canvas": true,
        [props.className ?? ""]: true,
      })}
      list={props.list}
    >
      {props.items.slice(0, MAX_ITEMS).map((user: IUserInfo, index: number) => (
        <UserTile
          key={index}
          user={user}
        />
      ))}
    </SeeMoreBlock>
  );
};
